import { makeStyles } from '@itsa.io/ui';

export default makeStyles(theme => ({
	root: {
		maxWidth: 500,
		width: '100%',
		textAlign: 'center',
	},
	textFieldAmount: {
		'& .MuiFilledInput-root, & .MuiFilledInput-root:hover': {
			border: 0,
			backgroundColor: 'transparent',
		},
	},
	textFieldEnode: {
		margin: theme.spacing(5, 0),
	},
	buttonFirstRow: {
		marginTop: 18,
	},
	buttonHorizontalGroup: {
		display: 'flex',
		flexDirection: 'column',
		justifyContent: 'space-between',
		width: '100%',
		maxWidth: 500,
		gap: theme.spacing(4),
		'& button': {
			width: '100%',
			maxWidth: '100%',
			margin: theme.spacing(0.75, 0),
			[theme.breakpoints.up('sm')]: {
				margin: theme.spacing(1.5, 0),
			},
		},
		[theme.breakpoints.up('sm')]: {
			flexDirection: 'row',
			'& button': {
				width: '100%',
			},
		},
		[theme.breakpoints.down('sm')]: {
			width: '85%',
			gap: theme.spacing(1),
			display: 'inline-flex',
			flexDirection: 'column-reverse',
		},
	},
	logo: {
		width: 96,
		height: 96,
		fontSize: 40,
		margin: theme.spacing(0, 'auto'),
		[theme.breakpoints.down('sm')]: {
			width: 80,
			height: 80,
		},
	},
	spaceBelow: {
		marginBottom: 22,
	},
	logoUnknown: {
		fontSize: 48,
		fontWeight: 500,
		color: theme.palette.secondary.light,
		margin: theme.spacing(0, 'auto'),
	},
	tokenDescription: {
		fontSize: 30,
		marginTop: theme.spacing(1),
		[theme.breakpoints.up('sm')]: {
			fontSize: 35,
			marginTop: theme.spacing(1.5),
		},
	},
	balance: {
		position: 'absolute',
		top: theme.spacing(1),
		right: theme.spacing(1),
		fontWeight: 500,
		textAlign: 'right',
	},
	symbolMaxAmount: {
		display: 'flex',
		justifyContent: 'flex-end',
		margin: theme.spacing(3, 0, 0, 0),
		'&>div': {
			fontSize: 20,
			fontWeight: 500,
			alignSelf: 'center',
			marginRight: theme.spacing(1),
		},
	},
	maxButtonWrap: {
		marginTop: theme.spacing(2),
		marginLeft: 'auto',
	},
	buttonMax: {
		borderRadius: 6,
		fontWeight: 500,
		color: theme.palette.grey[500],
		backgroundColor: theme.palette.orange[500],
		padding: theme.spacing(0.5, 2),
		'&:hover': {
			color: theme.palette.grey[500],
			backgroundColor: theme.palette.orange[300],
		},
	},
	iconButton: {
		margin: theme.spacing(0, 5),
		transition: 'all 0.5s ease',
	},
	iconButtonSwap: {
		MozTransform: 'rotate(180deg)',
		WebkitTransform: 'rotate(180deg)',
		OTransform: 'rotate(180deg)',
		transform: 'rotate(180deg)',
	},
	swapIcon: {
		fontSize: 50,
	},
	currentCollaterization: {
		fontSize: 18,
		position: 'relative',
		display: 'flex',
		justifyContent: 'center',
		margin: theme.spacing(5, 0, 5, 0),
	},
	amountCollaterization: {
		fontSize: 18,
		position: 'relative',
		display: 'flex',
		justifyContent: 'center',
		margin: theme.spacing(2, 0, 2, 0),
	},
	info: {
		position: 'relative',
		margin: theme.spacing(5, 0, 2, 0),
		'& a': {
			color: theme.palette.text.primary,
		},
		'& a:hover': {
			color: theme.palette.text.primary,
		},
		'& a:visited': {
			color: theme.palette.text.primary,
		},
	},
	tokenFrom: {
		position: 'absolute',
		fontSize: 30,
		top: 0,
		bottom: 0,
		left: 0,
		height: 40,
		margin: theme.spacing('auto', 0),
	},
	tokenTo: {
		position: 'absolute',
		fontSize: 30,
		top: 0,
		bottom: 0,
		right: 0,
		height: 40,
		margin: theme.spacing('auto', 0),
	},
	changingButton: {
		width: 'auto',
		'& .MuiButton-label': {
			width: 'auto',
			'&::after': {
				position: 'relative',
				top: -5,
				left: 5,
				content: '" ."',
				animation: `$dotAnim 1s steps(5, end) infinite`,
				fontSize: 25,
				lineHeight: 1,
			},
		},
	},
	warningIcon: {
		fontSize: '1.2rem',
		color: theme.palette.primary.main,
		marginRight: theme.spacing(1),
	},
	criticalBalanceDescription: {
		display: 'flex',
		fontSize: '0.85rem',
		textAlign: 'left',
		color: theme.palette.primary.main,
		marginTop: theme.spacing(3),
	},
	pendingTransaction: {
		animation: `$blink 1.5s infinite`,
	},
	sliderValueLabel: {
		display: 'flex',
		fontSize: '1rem',
	},
	sliderValueAmountLabel: {
		margin: theme.spacing('auto', 0),
	},
	'@keyframes blink': {
		'50%': {
			opacity: 0.5,
		},
	},
	'@keyframes dotAnim': {
		'0%, 20%': {
			color: 'rgba(0,0,0,0)',
			textShadow: '.25em 0 0 rgba(0,0,0,0), .5em 0 0 rgba(0,0,0,0)',
		},
		'40%': {
			color: theme.palette.primary.main,
			textShadow: '.25em 0 0 rgba(0,0,0,0), .5em 0 0 rgba(0,0,0,0)',
		},
		'60%': {
			textShadow: `.25em 0 0 ${theme.palette.primary.main}, .5em 0 0 rgba(0,0,0,0)`,
		},
		'80%, 100%': {
			textShadow: `.25em 0 0 ${theme.palette.primary.main}, .5em 0 0 ${theme.palette.primary.main}`,
		},
	},
}));
